module.exports = __webpack_public_path__ + "img/yjya-img01.26550fa7.png";